
<template>
    <div>
        <div
            v-if="(blockerFunctions.length > 0) || (blockerLists.length > 0) || (blockerAutomatics.length > 0)"
            class="card"
        >
            <div class="card-body mb-0 pb-0">
                <b-row class="ml-2 mb-1">
                    <h3>Automatisierte Sperrungen</h3>
                    <div>
                    <b-button
                        size="sm"
                        variant="outline-secondary"
                        class="ml-3 mb-1"
                        v-b-toggle="'collapse-blocker-product-table'"
                    >...</b-button></div>
                </b-row>
                <b-collapse id="collapse-blocker-product-table"> 
                    <div class="mx-4">
                        <b-row v-if="loading" align-v="center" class="m-4 p-2">
                            <b-col/>
                            <b-col align-h="center">
                                <div ><b-spinner style="width: 4rem; height: 4rem;" label="loading..."/></div>
                            </b-col>
                            <b-col/>
                        </b-row>

                        <b-row v-else>
                            <b-row class="my-2 col-12">
                                <h5 class="col-2">Funktions- sperrungen</h5>
                                    <b-table 
                                        v-if="blockerFunctions.length > 0"
                                        fixed
                                        hover
                                        size="sm"
                                        class="table-sm col-10"
                                        :fields="fields"
                                        :items="blockerFunctions"
                                    ><!-- table -->
                                        <template v-slot:cell(type)="row">
                                            <b-row>
                                                <b-col>
                                                  {{translateBlockerType(row.item.type)}}
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <template v-slot:cell(blackOrWhite)="row">
                                            <b-row>
                                                <b-col>
                                                    <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
                                                    <span v-else class="text-success">Freigabe</span>
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <template v-if="!loading" v-slot:cell(place)="row">
                                            <span v-if="row.item.countryId">Land <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
                                            <span v-else-if="row.item.marketId">Markt <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
                                            <span v-else-if="row.item.regionId">Region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
                                        </template>
                                    </b-table>
                            </b-row>
                            <b-row><hr></b-row>
                            <b-row class="my-2 col-12">
                                <h5 class="col-2">Sperrlisten</h5>
                                <b-table
                                    v-if="blockerLists.length > 0"
                                    fixed
                                    hover
                                    size="sm"
                                    class="table-sm col-10"
                                    :fields="fields"
                                    :items="blockerLists"
                                ><!-- table -->
                                    <template v-slot:cell(blackOrWhite)="row">
                                        <b-row>
                                            <b-col>
                                                <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
                                                <span v-else class="text-success">Freigabe</span>
                                            </b-col>
                                        </b-row>
                                    </template>
                                    <template v-if="!loading" v-slot:cell(place)="row">
                                        <span v-if="row.item.countryId">Land <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
                                        <span v-else-if="row.item.marketId">Markt <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
                                        <span v-else-if="row.item.regionId">Region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
                                    </template>
                                </b-table>
                            </b-row>
                            <b-row class="my-2 col-12">
                                <h5 class="col-2">automatische Sperrungen</h5>
                                <b-table
                                    v-if="blockerAutomatics.length > 0"
                                    fixed
                                    hover
                                    size="sm"
                                    class="table-sm col-10"
                                    :fields="fieldsAuto"
                                    :items="blockerAutomatics"
                                ><!-- table -->
                                    <template v-slot:cell(blackOrWhite)="row">
                                        <b-row>
                                            <b-col>
                                                <span v-if="row.item.blackOrWhite" class="text-danger">Sperrung</span>
                                                <span v-else class="text-success">Freigabe</span>
                                            </b-col>
                                        </b-row>
                                    </template>
                                    <template v-if="!loading" v-slot:cell(place)="row">
                                        <span v-if="row.item.countryId">Land <b>{{countries.find( country => country.id === row.item.countryId).name }}</b></span>
                                        <span v-else-if="row.item.marketId">Markt <b>{{markets.find( market => market.id === row.item.marketId).name }}</b></span>
                                        <span v-else-if="row.item.regionId">Region <b>{{regions.find( region => region.id === row.item.regionId).name }}</b></span>
                                    </template>
                                </b-table>
                            </b-row>
                        </b-row>
                    </div>
                </b-collapse>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    export default {
        name: 'blockerProductTable',
        props: [
            "productId"
        ],
        data() {
            return {
                loading: true,
                showTitle: true,
                fields: [
                    { key: 'type',          label: 'Typ', thStyle: '' },
                    { key: 'name',          label: 'Name', thStyle: ''},
                    { key: 'blackOrWhite',  label: 'Sperrung/Freigabe', thStyle: ''},
                    { key: 'place',         label: 'Region', thStyle: ''}
                ],
                fieldsAuto: [
                    { key: 'reason',        label: 'Grund', thStyle: ''},
                    { key: 'blackOrWhite',  label: 'Sperrung/Freigabe', thStyle: ''},
                    { key: 'place',         label: 'Region', thStyle: ''}
                ],
                blockerLists: [],
                blockerAutomatics: [],
                blockerFunctions: [],
                blockerListProduct: [],
                countries: [],
                markets: [],
                regions: []
            }
        },
      methods: {
            translateBlockerType(type) {
                if(type === 'regex'){
                  return "Wortliste"
                } else if (type === 'ean'){
                  return 'Barcodestamm'
                } else if (type === 'function'){
                  return 'Funktion'
                } else {
                  return type;
                }
            }
        },
        mounted() {
            this.loading = true;
            Promise.all([
                axios.get(`/mds/blocker_list/by_product_id/${this.productId}`), //TODO change to normal routes!
                axios.get(`/mds/blocker_function/by_product_id/${this.productId}`),
                axios.get(`/mds/blocker_automatic/by_product_id/${this.productId}`),
                axios.get(`/mds/country`),
                axios.get(`/mds/market`),
                axios.get(`/mds/region`)
            ]).then( ([
                blockerListResponse,
                blockerFunctionResponse,
                blockerAutomaticResponse,
                countryResponse,
                marketResponse,
                regionResponse
            ]) => {
                this.blockerLists = blockerListResponse.data;
                this.blockerFunctions = blockerFunctionResponse.data;
                this.blockerAutomatics = blockerAutomaticResponse.data; 
                this.countries = countryResponse.data;
                this.markets = marketResponse.data;
                this.regions = regionResponse.data;
                this.loading = false;
            }).catch( error => {
                console.log(error);
            });
        }
    }
</script>
